export class AuthCore {
  constructor(store, auth) {
    this.store = store
    this.auth = auth
  }
  get isAuthenticated() {
    return this.store.getters.isAuthenticated
  }
  get userRole() {
    return this.store.getters.userRole
  }
  get userLogin() {
    return this.store.getters.userLogin
  }
  SignIn(params) {
    this.store.dispatch('SIGNIN', params)
  }
  async GetAuthGuid() {
    return await this.store.dispatch('GETAUTHGUID')
  }

  async SignInByDigitalSignature(sign) {
    return await this.store.dispatch('SIGNIN_BY_DIGITAL_SIGNATURE', sign)
  }
  
  async SignInSendSMS(params)  {
    return await this.store.dispatch('SIGNIN_SEND_SMS_CODE', params)
  }
  async SignInSendOneTimePass(params) {
    await this.store.dispatch('SIGNIN_SEND_ONE_TIME_PASS', params)
  }
  async SignInByCode(params) {
    await this.store.dispatch('SIGN_IN_BY_CODE', params)
  }
  SetUserRole(userRole) {
    this.store.commit('SET_USER_ROLE', userRole)
  }
  SignOut() {
    this.store.dispatch('SIGNOUT')
  }
  async updateUserData()  {
    await this.store.dispatch('UPDATE_USER_DATA')
  }
  
  SetAdditionalUserDataHandler(handler) {
    this.getAdditionalUserData = handler
  }
  async getAdditionalUserData() {
    return Promise.resolve(null)
  }

  async _getAdditionalUserData() {
    if (this.getAdditionalUserData) {
      await this.getAdditionalUserData()
    }
  }
    
}
